import { computed, getCurrentInstance } from 'vue';
import { compareVersion } from '~/common/utils';

type CaptionItemProps = {
    caption?: string;
};

export const CaptionItemAppSetup = (props: CaptionItemProps) => {
    const { proxy } = getCurrentInstance() || {};

    const hashtagLinksText = computed(() => {
        if ((props.caption || '').length === 0) {
            return '';
        }

        const hashtagRegex = /#((?:[^#])*)/g;

        const appVersion = proxy?.$appConfig?.appver;
        // 这里做版控原因
        // HashTag的展示需要先通过Google Play的审核，因此限制即将提审的版本1.8.2显示HashTag
        // 后面当GP过审后，再改动代码，所有版本都显示HashTag
        // todo @jinyao
        if (appVersion && compareVersion(appVersion, '1.8.2') >= 0) {
            const replacedStr = (props.caption || '').replace(/\([^()]*\)/g, '').replace(hashtagRegex, match => {
                return `<span class='hast-tag' style="color: grey;">${match}</span>`;
            });
            return replacedStr;
        }

        const replacedStr = (props.caption || '').replace(/\([^()]*\)/g, '').replace(hashtagRegex, (match, p1) => {
            return `<span class='hast-tag'> ${p1}</span>`;
        });

        return replacedStr;
    });

    return {
        hashtagLinksText,
    };
};
